import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { DiscussionReactionModel } from '@smarttask-common/src/lib/models/Discussion/Reaction/DiscussionReactionModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class DiscussionsHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.discussion_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.discussion_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.discussion_new, (group_id: string, discussion_id: string, project_id: string = undefined) => {
            this.broadcast(SharedEventNameEnum.discussion_new, { group_id, discussion_id, project_id });
        });

        this.on(SharedEventNameEnum.discussion_update, (discussion_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_update, { discussion_id });
        });

        this.on(SharedEventNameEnum.discussion_reactions_update, (discussion_id: string, reaction: DiscussionReactionModel) => {
            this.broadcast(SharedEventNameEnum.discussion_reactions_update, { discussion_id, reaction });
        });

        this.on(SharedEventNameEnum.discussion_followers_update, (discussion_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_followers_update, { discussion_id });
        });

        this.on(SharedEventNameEnum.discussion_delete, (discussion_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_delete, { discussion_id });
        });

        this.on(SharedEventNameEnum.discussion_comment_new, (discussion_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_comment_new, { discussion_id, activity_id });
        });

        this.on(SharedEventNameEnum.discussion_comment_update, (discussion_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_comment_update, { discussion_id, activity_id });
        });

        this.on(
            SharedEventNameEnum.discussion_comment_reactions_update,
            (discussion_id: string, activity_id: string, reaction: DiscussionReactionModel) => {
                this.broadcast(SharedEventNameEnum.discussion_comment_reactions_update, { discussion_id, activity_id, reaction });
            },
        );

        this.on(SharedEventNameEnum.discussion_comment_delete, (discussion_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.discussion_comment_delete, { discussion_id, activity_id });
        });
    };
}
